import style from './style';

const Overlay = (props) => {
    const changeEpisode = (newSite) => {
        if (props.site === newSite) {
            return;
        }
        const isReturn = newSite < props.site;
        props.setVisible(false);
        props.handleSiteChange(newSite, isReturn, props.loadedImages);
    };

    const glitchClass = () => {
        if (props.site !== 7 || Math.random() < 0.6) {
            return
        }
        let picNumber = Math.floor(Math.random() * 13) + 1;
        return style['overlay-glitch--' + props.site]
        + ' '
        + style['overlay-glitch-' + picNumber + '--' + props.site];
    };

    return (
        props.isVisible ?
            <div class={`${style['overlay-wrapper--' + props.site]} ${style['overlay-wrapper']}`}>
                <div
                    className={`${style['overlay__button--' + props.site]} ${style['overlay__button']}`}
                    onClick={props.closeOverlay}>Закрыть
                </div>
                <div class={`${style['overlay--' + props.site]} ${style['overlay']}`}>
                    {
                        props.content === 'o-projekte' &&
                        <div className={`${style['overlay__small--' + props.site]} ${style['overlay__small']}`}>
                            <h1>
                                О проекте
                            </h1>
                            <div className={`${style['overlay__small-inner']} ${style['overlay__small-inner--' + props.site]}`}>
                                <p>Авторский сериал Андрея Лошака рассказывает о том, как возник в России интернет,
                                    прозванный “Рунетом”, и как он
                                    со временем менялся. Развитие Рунета отразило все социальные и политические
                                    изменения в российском обществе:
                                    полная свобода в 90-х годах, бурный рост экономики в нулевых и введение цензуры и
                                    запретительных законов
                                    в десятые. Последние семь лет государство активно пытается взять Рунет под
                                    контроль.</p>
                                <p>Слушайте подкаст по эпизодам:
                                    <a href="https://www.currenttime.tv/a/holywar-loshak-runet-odcast/30145893.html"
                                       target='_blank'>
                                        1
                                    </a>

                                    <a href="https://www.currenttime.tv/a/holywar-podcast-two-loshak/30158526.html"
                                       target='_blank'>
                                        2
                                    </a>
                                    <a href="https://www.currenttime.tv/a/podcast-holywar-loshak/30170907.html"
                                       target='_blank'>
                                        3
                                    </a>
                                    <a href="https://www.currenttime.tv/a/holywar-podcast-loshak/30184763.html"
                                       target='_blank'>
                                        4
                                    </a>
                                    <a href="https://www.currenttime.tv/a/holywar-podcast-loshak/30196874.html"
                                       target='_blank'>
                                        5
                                    </a>
                                    <a href="https://www.currenttime.tv/a/podcas-holywar-loshak/30210021.html"
                                       target='_blank'>
                                        6
                                    </a>
                                    <a href="https://www.currenttime.tv/a/podcast-holywar-loshak/30221243.html"
                                       target='_blank'>
                                        7
                                    </a>
                                </p>
                            </div>
                        </div>
                    }
                    {
                        props.content === 'ob-avtore' &&
                        <div className={`${style['overlay__small--' + props.site]} ${style['overlay__small']}`}>
                            <h1>
                                Об авторе
                            </h1>
                            <div className={`${style['overlay__small-inner']} ${style['overlay__small-inner--' + props.site]}`}>
                                <div class={`${style['overlay__image--' + props.site]} ${style['overlay__image']}`}>
                                    <img
                                        src='https://docs.rferl.org/Infographics/2019/2019_07/2019_07_HolyWar/images/loshak.jpg'/>
                                </div>
                                <p><span class={`${style['overlay__small-name--' + props.site]}`}>Андрей Лошак</span> – российский журналист, репортер. В прошлом автор телепередач "Намедни",
                                    "Профессия – репортер" на НТВ и шоу "Большой город" на СТС, бывший редакционный
                                    директор журнала Esquire.</p>

                                <p>Обладатель премии "Лавровая ветвь" за сериал "Путешествие из Петербурга в Москву:
                                    особый путь" и и Гран-при конкурса "Артдоксеть" за сериал "Возраст несогласия".
                                    Сооснователь информационного портала о благотворительности и социальных проблемах
                                    "Такие дела".</p>
                            </div>
                        </div>
                    }
                    {
                        props.content === 'o-gerojah' &&
                        <div className={`${style['overlay__large-inner']} ${style['overlay__large-inner--' + props.site]}`}>
                            <h1>
                                О героях
                            </h1>

                            <div
                                className={`${style['overlay__characters--' + props.site]} ${style['overlay__characters']}`}>
                                <div className={glitchClass()}>
                                    <img
                                        src='https://docs.rferl.org/Infographics/2019/2019_07/2019_07_HolyWar/images/about-the-heroes/05-aleksandr-mamut.jpg'/>
                                </div>
                                <div>
                                    <h3>Александр Мамут</h3>
                                    <p>предприниматель, миллиардер. Соучредитель и бывший акционер сети магазинов "Седьмой континент",
                                        бывший председатель совета директоров МДМ-банка, компании "Тройка Диалог", а также бывший член
                                        совета директоров "Ингосстраха". В 2007 году организовал компанию SUP, купившую сервис LiveJournal.
                                        В 2008 году выкупил 100 % акций компании "Евросеть", после возбуждения уголовного дела против
                                        основателя компании Евгения Чичваркина. Управляющий акционер Rambler&Co, владелец сети кинотеатров
                                        "Синема парк" и "Формула кино".</p>
                                </div>
                            </div>

                            <div
                                className={`${style['overlay__characters--' + props.site]} ${style['overlay__characters']}`}>
                                <div className={glitchClass()}>
                                    <img
                                        src='https://docs.rferl.org/Infographics/2019/2019_07/2019_07_HolyWar/images/about-the-heroes/06-Aleksandr-Plustschev.jpg'/>
                                </div>
                                <div>
                                    <h3>Александр Плющев</h3>
                                    <p>журналист, блогер, радио- и телеведущий.
                                        Автор цикла интервью "Эти ваши интернеты".
                                        Решением Михаила Лесина – председателя совета директоров "Газпром-медиа" – был уволен из "Эха Москвы"
                                        за "нарушение профессиональной этики". Увольнение было связано то ли со скандальным
                                        твитом о гибели зампреда Внешэкономбанка, то ли с эфиром программы о войне в Украине.
                                        Спустя три недели приказ об увольнении отменили.</p>
                                </div>
                            </div>

                            <div
                                className={`${style['overlay__characters--' + props.site]} ${style['overlay__characters']}`}>
                                <div className={glitchClass()}>
                                    <img
                                        src='https://docs.rferl.org/Infographics/2019/2019_07/2019_07_HolyWar/images/about-the-heroes/04-alexey-krivenkov.jpg'/>
                                </div>
                                <div>
                                    <h3>Алексей Кривенков</h3>
                                    <p>разработчик первого русскоязычного почтового сервиса Mail.ru. В 1996 году бросил учебу в России
                                        и уехал покорять Нью-Йорк, где познакомился с будущим бизнес-партнером Евгением Голландом.
                                        Спустя 2 года запустил сайт Mail.ru и вернулся в Россию.</p>
                                </div>
                            </div>

                            <div
                                className={`${style['overlay__characters--' + props.site]} ${style['overlay__characters']}`}>
                                <div className={glitchClass()}>
                                    <img
                                        src='https://docs.rferl.org/Infographics/2019/2019_07/2019_07_HolyWar/images/about-the-heroes/05-alexey-navalny.jpg'/>
                                </div>
                                <div>
                                    <h3>Алексей Навальный</h3>
                                    <p>политик, юрист, общественный деятель. Создатель Фонда борьбы с коррупцией, автор двух ютуб-каналов.
                                        Занял второе место на выборах мэра Москвы в 2013 году, до президентских выборов в 2016 году не был
                                        допущен. Автор мема "партия жуликов и воров" и одного из самых популярных блогов в "Живом Журнале",
                                        заблокированного Роскомнадзором.</p>
                                </div>
                            </div>


                            <div
                                className={`${style['overlay__characters--' + props.site]} ${style['overlay__characters']}`}>
                                <div className={glitchClass()}>
                                    <img
                                        src='https://docs.rferl.org/Infographics/2019/2019_07/2019_07_HolyWar/images/about-the-heroes/04-alisher-usmanov.jpg'/>
                                </div>
                                <div>
                                    <h3>Алишер Усманов</h3>
                                    <p>один из богатейших людей РФ, предприниматель, меценат. Родился в Ташкенте. В 1987 году учредил кооператив "Агропласт",
                                        занимался производством пластиковых пакетов и поставкой табака. Соучредитель компании "Металлоинвест", МАПО-банка,
                                        бывший советник председателя правления ОАО "Газпром" и генеральный директор "Газпроминвестхолдинга".
                                        Инвестировал в первые международные фонды под правлением DST Global.</p>
                                </div>
                            </div>

                            <div
                                className={`${style['overlay__characters--' + props.site]} ${style['overlay__characters']}`}>
                                <div className={glitchClass()}>
                                    <img
                                        src='https://docs.rferl.org/Infographics/2019/2019_07/2019_07_HolyWar/images/about-the-heroes/04-albert-popkov.jpg'/>
                                </div>
                                <div>
                                    <h3>Альберт Попков</h3>
                                    <p>российский программист, создатель сайта Odnoklassniki.ru. Подростком разрабатывал программное обеспечение
                                        для советских игровых компьютеров "Корвет". В 90-х работал продавцом, строителем и сушильщиком на карандашной
                                        фабрике. Сайт Odnoklassniki.ru создал во время шестимесячного перерыва между работой программистом в одной
                                        справочной службе и переходом в другую.</p>
                                </div>
                            </div>

                            <div
                                className={`${style['overlay__characters--' + props.site]} ${style['overlay__characters']}`}>
                                <div className={glitchClass()}>
                                    <img
                                        src='https://docs.rferl.org/Infographics/2019/2019_07/2019_07_HolyWar/images/about-the-heroes/07-andrey-doronichev.jpg'/>
                                </div>
                                <div>
                                    <h3>Андрей Дороничев</h3>
                                    <p>глава направления виртуальной реальности в Google.
                                        До этого разрабатывал мобильное приложение YouTube.
                                        Основатель "Доброго дома" – сообщества русскоязычных стартаперов в США.</p>
                                </div>
                            </div>

                            <div
                                className={`${style['overlay__characters--' + props.site]} ${style['overlay__characters']}`}>
                                <div className={glitchClass()}>
                                    <img
                                        src='https://docs.rferl.org/Infographics/2019/2019_07/2019_07_HolyWar/images/about-the-heroes/05-andrey-klishas.jpg'/>
                                </div>
                                <div>
                                    <h3>Андрей Клишас</h3>
                                    <p>политик, предприниматель, миллионер. В 90-х работал в Российском фонде федерального имущества,
                                        бывший президент "Норильского никеля". Автор законопроекта "О суверенном интернете".</p>
                                </div>
                            </div>

                            <div
                                className={`${style['overlay__characters--' + props.site]} ${style['overlay__characters']}`}>
                                <div className={glitchClass()}>
                                    <img
                                        src='https://docs.rferl.org/Infographics/2019/2019_07/2019_07_HolyWar/images/about-the-heroes/05-andrey-lugovoy.jpg'/>
                                </div>
                                <div>
                                    <h3>Андрей Луговой</h3>
                                    <p>политик, предприниматель. Родился в семье военнослужащих. В 90-х работал в Главном управлении охраны
                                        РФ и Службе безопасности президента РФ, позже возглавил службу безопасности телеканала ОРТ. Директор
                                        группы охранных предприятий и совладелец компании, выпускающей квас. Подозревается прокуратурой
                                        Великобритании в убийстве Александра Литвиненко. Автор закона о блокировке экстремистских сайтов
                                        и закона о "суверенном интернете".</p>
                                </div>
                            </div>

                            <div
                                class={`${style['overlay__characters--' + props.site]} ${style['overlay__characters']}`}>
                                <div className={glitchClass()}>
                                    <img
                                        src='https://docs.rferl.org/Infographics/2019/2019_07/2019_07_HolyWar/images/about-the-heroes/01-anton-nosik.jpg'/>
                                </div>
                                <div>
                                    <h3>Антон Носик</h3>
                                    <p>журналист, стартап-менеджер, блогер, бывший главный редактор ряда проектов ФЭП
                                        (Фонда эффективной политики):
                                        Vesti.ru, Lenta.ru, Gazeta.ru и NEWSru.com. Участвовал в развитии
                                        контент-проектов для интернет-провайдера
                                        CityLine, таких как блог "Вечерний интернет". Умер в 2017 году от сердечного
                                        приступа.</p>
                                </div>
                            </div>

                            <div
                                className={`${style['overlay__characters--' + props.site]} ${style['overlay__characters']}`}>
                                <div className={glitchClass()}>
                                    <img
                                        src='https://docs.rferl.org/Infographics/2019/2019_07/2019_07_HolyWar/images/about-the-heroes/03-arkadiy-volozh.jpg'/>
                                </div>
                                <div>
                                    <h3>Аркадий Волож</h3>
                                    <p>сооснователь и руководитель группы компаний Yandex. В 1989 году открыл компанию
                                        по продаже
                                        компьютеров и программного обеспечения CompTek. С 2007 года заведующий кафедрой
                                        "Анализ
                                        данных" МФТИ. По оценке журнала Forbes занимает 65 место среди самых богатых
                                        людей России.</p>
                                </div>
                            </div>

                            <div
                                className={`${style['overlay__characters--' + props.site]} ${style['overlay__characters']}`}>
                                <div className={glitchClass()}>
                                    <img
                                        src='https://docs.rferl.org/Infographics/2019/2019_07/2019_07_HolyWar/images/about-the-heroes/01-arsen-revazov.jpg'/>
                                </div>
                                <div>
                                    <h3>Арсен Ревазов</h3>
                                    <p>писатель, фотограф, автор "белой ленточки" – символа протестов, связанного с
                                        выборами в 2011 году.
                                        В 1999-м основал рекламное агентство IMHO, в течение 12 лет эксклюзивно
                                        продающего баннеры на
                                        главной странице Yandex.</p>
                                </div>
                            </div>

                            <div
                                className={`${style['overlay__characters--' + props.site]} ${style['overlay__characters']}`}>
                                <div className={glitchClass()}>
                                    <img
                                        src='https://docs.rferl.org/Infographics/2019/2019_07/2019_07_HolyWar/images/about-the-heroes/05-artem-kozlyuk.jpg'/>
                                </div>
                                <div>
                                    <h3>Артем Козлюк</h3>
                                    <p>общественный и политический деятель. Член штаба Пиратской партии России, руководитель проекта "РосКомСвобода",
                                        соучредитель и член правления "Ассоциации пользователей интернета".</p>
                                </div>
                            </div>

                            <div
                                className={`${style['overlay__characters--' + props.site]} ${style['overlay__characters']}`}>
                                <div className={glitchClass()}>
                                    <img
                                        src='https://docs.rferl.org/Infographics/2019/2019_07/2019_07_HolyWar/images/about-the-heroes/01-artemy-lebedev.jpg'/>
                                </div>
                                <div>
                                    <h3>Артемий Лебедев</h3>
                                    <p>первый веб-дизайнер в России. Обладатель одного из самых популярных ЖЖ, автор
                                        книги "Ководство",
                                        отец десяти детей. Известен своей дерзостью в интернете и обилием нецензурной
                                        лексики в постах.</p>
                                </div>
                            </div>

                            <div
                                className={`${style['overlay__characters--' + props.site]} ${style['overlay__characters']}`}>
                                <div className={glitchClass()}>
                                    <img
                                        src='https://docs.rferl.org/Infographics/2019/2019_07/2019_07_HolyWar/images/about-the-heroes/01-bayan-shiryanov.jpg'/>
                                </div>
                                <div>
                                    <h3>Баян Ширянов</h3>
                                    <p>российский писатель. Первые тексты попали в интернет без ведома автора. Стал
                                        известен благодаря
                                        роману "Низший пилотаж" о жизни московских наркоманов. В 2002 году книги
                                        Ширянова и
                                        Владимира Сорокина публично уничтожали активисты движения "Идущие вместе".
                                        Писатель умер
                                        в 2017 году от цирроза печени.</p>
                                </div>
                            </div>

                            <div
                                className={`${style['overlay__characters--' + props.site]} ${style['overlay__characters']}`}>
                                <div className={glitchClass()}>
                                    <img
                                        src='https://docs.rferl.org/Infographics/2019/2019_07/2019_07_HolyWar/images/about-the-heroes/04-boris-dobrodeev.jpg'/>
                                </div>
                                <div>
                                    <h3>Борис Добродеев</h3>
                                    <p>сын генерального директора ВГТРК Олега Добродеева. Окончил исторический факультет МГУ. Работал аналитиком
                                        в компании "Металлоинвест" Алишера Усманова и DST Advisers Юрия Мильнера. После увольнения Павла Дурова
                                        стал генеральным директором "ВКонтакте", а позже стал директором Mail.ru Group.</p>
                                </div>
                            </div>

                            <div
                                className={`${style['overlay__characters--' + props.site]} ${style['overlay__characters']}`}>
                                <div className={glitchClass()}>
                                    <img
                                        src='https://docs.rferl.org/Infographics/2019/2019_07/2019_07_HolyWar/images/about-the-heroes/05-brad-fitzpatrick.jpg'/>
                                </div>
                                <div>
                                    <h3>Брэд Фицпатрик</h3>
                                    <p>американский программист. Родился в Айове. Во время учебы в Вашингтонском университете в Сиэтле создал
                                        сайт LiveJournal для собственного использования. Сейчас живет в Сан-Франциско и работает в компании Google.</p>
                                </div>
                            </div>

                            <div
                                className={`${style['overlay__characters--' + props.site]} ${style['overlay__characters']}`}>
                                <div className={glitchClass()}>
                                    <img
                                        src='https://docs.rferl.org/Infographics/2019/2019_07/2019_07_HolyWar/images/about-the-heroes/06-Vadim-Tumencev.jpg'/>
                                </div>
                                <div>
                                    <h3>Вадим Тюменцев</h3>
                                    <p>видеоблогер, гражданский активист, ученый-любитель.
                                        В 2015 году был приговорен к пяти годам колонии общего режима за "публичные призывы к экстремизму"
                                        и "возбуждение ненависти и вражды" к гражданам, проживающим
                                        на территории Луганской и Донецкой областей Украины.</p>
                                </div>
                            </div>

                            <div
                                className={`${style['overlay__characters--' + props.site]} ${style['overlay__characters']}`}>
                                <div className={glitchClass()}>
                                    <img
                                        src='https://docs.rferl.org/Infographics/2019/2019_07/2019_07_HolyWar/images/about-the-heroes/05-vasily-yakemenko.jpg'/>
                                </div>
                                <div>
                                    <h3>Василий Якеменко</h3>
                                    <p>политик, общественный деятель, идеолог молодёжных движений "Идущие вместе" (2000 г.), "Наши" (2005 г.)
                                        и молодежного форума "Селигер". С 2007 Якеменко запрещен въезд в страны Шенгенского договора по требованию
                                        Эстонии, обвинившей политика в организации нападения на посла Марину Кальюранд. С 2017 года занимается
                                        бизнесом: открыл сеть кафе "Ешь пирог", коуч-сервис "Адвокат тела" и "Школу великих книг".</p>
                                </div>
                            </div>

                            <div
                                className={`${style['overlay__characters--' + props.site]} ${style['overlay__characters']}`}>
                                <div className={glitchClass()}>
                                    <img
                                        src='https://docs.rferl.org/Infographics/2019/2019_07/2019_07_HolyWar/images/about-the-heroes/03-viktor-huako.jpg'/>
                                </div>
                                <div>
                                    <h3>Виктор Хуако</h3>
                                    <p>перуанец, основатель Orion Capital. В начале 90-х переехал в Москву, где торговал
                                        государственными
                                        ценными бумагами и искал свежие бизнес-идеи. Первый иностранный инвестор
                                        компании Rambler.</p>
                                </div>
                            </div>

                            <div
                                className={`${style['overlay__characters--' + props.site]} ${style['overlay__characters']}`}>
                                <div className={glitchClass()}>
                                    <img
                                        src='https://docs.rferl.org/Infographics/2019/2019_07/2019_07_HolyWar/images/about-the-heroes/05-vitaly-bespalov.jpg'/>
                                </div>
                                <div>
                                    <h3>Виталий Беспалов</h3>
                                    <p>бывший сотрудник "фабрики троллей", где писал тексты о военном конфликте в Украине и США. В 2017 году
                                        рассказал NBC NEWS о специфике работы компании. Сейчас работает в проекте "Парни плюс" – сайте
                                        о сексуальном здоровье для ЛГБТ.</p>
                                </div>
                            </div>

                            <div
                                className={`${style['overlay__characters--' + props.site]} ${style['overlay__characters']}`}>
                                <div className={glitchClass()}>
                                    <img
                                        src='https://docs.rferl.org/Infographics/2019/2019_07/2019_07_HolyWar/images/about-the-heroes/05-vladislav-surkov.jpg'/>
                                </div>
                                <div>
                                    <h3>Владислав Сурков</h3>
                                    <p>политик, помощник президента РФ. В 1999 году стал заместителем руководителя администрации президента
                                        РФ. Считается одним из создателей и главных идеологов партии "Единая Россия", а также молодежных проектов
                                        "Идущие вместе" и "Наши". Любитель русского рока, соавтор нескольких текстов песен Вадима Самойлова –
                                        бывшего участника группы "Агата Кристи".</p>
                                </div>
                            </div>

                            <div
                                className={`${style['overlay__characters--' + props.site]} ${style['overlay__characters']}`}>
                                <div className={glitchClass()}>
                                    <img
                                        src='https://docs.rferl.org/Infographics/2019/2019_07/2019_07_HolyWar/images/about-the-heroes/06-Galina-Timchenko.jpg'/>
                                </div>
                                <div>
                                    <h3>Галина Тимченко</h3>
                                    <p>журналист, бывший главный редактор Lenta.ru (2004-2014).
                                        Генеральный директор и учредитель новостного проекта Meduza – русскоязычного портала, зарегистрированного в Латвии.
                                        После скандального увольнения из Lenta.ru за Тимченко в новый проект ушли 77 из 84 журналистов издания.</p>
                                </div>
                            </div>

                            <div
                                className={`${style['overlay__characters--' + props.site]} ${style['overlay__characters']}`}>
                                <div className={glitchClass()}>
                                    <img
                                        src='https://docs.rferl.org/Infographics/2019/2019_07/2019_07_HolyWar/images/about-the-heroes/04-georgy-lobushkin.jpg'/>
                                </div>
                                <div>
                                    <h3>Георгий Лобушкин</h3>
                                    <p>бывший руководитель пресс-службы "ВКонтакте" (2011-2016 годы) и директор по стратегическим коммуникациям
                                        Mail.ru Group (2016-2017 годы). В настоящее время занимается связями с общественностью такси-сервиса "Ситимобил".</p>
                                </div>
                            </div>

                            <div
                                className={`${style['overlay__characters--' + props.site]} ${style['overlay__characters']}`}>
                                <div className={glitchClass()}>
                                    <img
                                        src='https://docs.rferl.org/Infographics/2019/2019_07/2019_07_HolyWar/images/about-the-heroes/01-egor-shuppe.jpg'/>
                                </div>
                                <div>
                                    <h3>Георгий Шуппе</h3>
                                    <p>президент компании CityLine, сооснователь первого в России онлайн-медиа и
                                        контент-провайдера
                                        "Нетскейт", купившего Anekdot.ru и создавшего "Вечерний интернет",
                                        "Паровозов-ньюс" и "Сеновал".</p>
                                </div>
                            </div>

                            <div
                                className={`${style['overlay__characters--' + props.site]} ${style['overlay__characters']}`}>
                                <div className={glitchClass()}>
                                    <img
                                        src='https://docs.rferl.org/Infographics/2019/2019_07/2019_07_HolyWar/images/about-the-heroes/01-herman-klimenko.jpg'/>
                                </div>
                                <div>
                                    <h3>Герман Клименко</h3>
                                    <p>интернет-предприниматель, владелец компании LiveInternet и MediaMetricks –
                                        новостного агрегатора
                                        данных на основе соцсетей. С 2016 по 2018-й был советником президента РФ по
                                        вопросам развития интернета.</p>
                                </div>
                            </div>

                            <div
                                className={`${style['overlay__characters--' + props.site]} ${style['overlay__characters']}`}>
                                <div className={glitchClass()}>
                                    <img
                                        src='https://docs.rferl.org/Infographics/2019/2019_07/2019_07_HolyWar/images/about-the-heroes/02-gleb-pavlovsky.jpg'/>
                                </div>
                                <div>
                                    <h3>Глеб Павловский</h3>
                                    <p>советский диссидент, журналист, политолог. Соучредитель и директор Фонда
                                        эффективной политики.
                                        Был советником руководителя администрации президента РФ, после чего ушел в
                                        оппозицию.</p>
                                </div>
                            </div>

                            <div
                                className={`${style['overlay__characters--' + props.site]} ${style['overlay__characters']}`}>
                                <div className={glitchClass()}>
                                    <img
                                        src='https://docs.rferl.org/Infographics/2019/2019_07/2019_07_HolyWar/images/about-the-heroes/05-grigory-asmolov.jpg'/>
                                </div>
                                <div>
                                    <h3>Григорий Асмолов</h3>
                                    <p>научный сотрудник Института России Королевского колледжа Лондона, создатель "Карты помощи пострадавшим
                                        от пожаров" в 2010 году. Сейчас продолжает исследовать роль соцсетей и информационных технологий
                                        в формировании сознания народных масс.</p>
                                </div>
                            </div>

                            <div
                                className={`${style['overlay__characters--' + props.site]} ${style['overlay__characters']}`}>
                                <div className={glitchClass()}>
                                    <img
                                        src='https://docs.rferl.org/Infographics/2019/2019_07/2019_07_HolyWar/images/about-the-heroes/05-grigory-okhotin.jpg'/>
                                </div>
                                <div>
                                    <h3>Григорий Охотин</h3>
                                    <p>журналист, независимый исследователь. Сооснователь правозащитного проекта "ОВД-Инфо" и Data4Society
                                        – сообщества журналистов и программистов, занимающихся анализом и популяризацией общественно полезных данных.</p>
                                </div>
                            </div>

                            <div
                                className={`${style['overlay__characters--' + props.site]} ${style['overlay__characters']}`}>
                                <div className={glitchClass()}>
                                    <img
                                        src='https://docs.rferl.org/Infographics/2019/2019_07/2019_07_HolyWar/images/about-the-heroes/05-grigory-pastshenko.jpg'/>
                                </div>
                                <div>
                                    <h3>Григорий Пащенко</h3>
                                    <p>глава общественного движения "Кибердружина". По словам Пащенко, дружинники закрыли около 50
                                        "серьезных экстремистских сообществ", среди которых паблик "Синий кит".</p>
                                </div>
                            </div>

                            <div
                                className={`${style['overlay__characters--' + props.site]} ${style['overlay__characters']}`}>
                                <div className={glitchClass()}>
                                    <img
                                        src='https://docs.rferl.org/Infographics/2019/2019_07/2019_07_HolyWar/images/about-the-heroes/06-David-Homak.jpg'/>
                                </div>
                                <div>
                                    <h3>Давид Хомак</h3>
                                    <p>программист, один из создателей и владелец сайта Луркоморье.
                                        В 2013 году был вынужден эмигрировать в Израиль из-за проблем с Роскомнадзором
                                        и Центром по борьбе с экстремизмом</p>
                                </div>
                            </div>

                            <div
                                className={`${style['overlay__characters--' + props.site]} ${style['overlay__characters']}`}>
                                <div className={glitchClass()}>
                                    <img
                                        src='https://docs.rferl.org/Infographics/2019/2019_07/2019_07_HolyWar/images/about-the-heroes/07-danila-poperechny.jpg'/>
                                </div>
                                <div>
                                    <h3>Данила Поперечный</h3>
                                    <p>видеоблогер, стендап-комик. Бывший мультипликатор "Спасибо, Ева!" Автор шоу "Зашкварные истории"
                                        на ютуб-канале "КЛИККЛАК" и один из создателей портала "ДавайЛайма".
                                        У ютуб-канала Поперечного более 2,6 миллионов подписчиков.</p>
                                </div>
                            </div>

                            <div
                                className={`${style['overlay__characters--' + props.site]} ${style['overlay__characters']}`}>
                                <div className={glitchClass()}>
                                    <img
                                        src='https://docs.rferl.org/Infographics/2019/2019_07/2019_07_HolyWar/images/about-the-heroes/01-demyan-kudryavtzev.jpg'/>
                                </div>
                                <div>
                                    <h3>Демьян Кудрявцев</h3>
                                    <p>один из руководителей компании CityLine, гражданин Израиля. Впоследствии –
                                        генеральный директор
                                        ИД "Коммерсант", акционер Sanoma Independent Media. В 2017 году МВД России
                                        отменило свое решение
                                        о предоставлении гражданства Кудрявцеву, многие считают, что поводом послужили
                                        журналистские расследования.</p>
                                </div>
                            </div>

                            <div
                                className={`${style['overlay__characters--' + props.site]} ${style['overlay__characters']}`}>
                                <div className={glitchClass()}>
                                    <img
                                        src='https://docs.rferl.org/Infographics/2019/2019_07/2019_07_HolyWar/images/about-the-heroes/01-joel-shatz.jpg'/>
                                </div>
                                <div>
                                    <h3>Джоэл Шац</h3>
                                    <p>изучал психологию, химию, философию науки и теорию коммуникаций в 60-х. Работал в
                                        администрации
                                        штата Орегон. Хиппи и любитель психоделических наркотиков. Создатель и идеолог
                                        первого телемоста между
                                        СССР и США, который, по его задумке, должен был объединить людей так же, как это
                                        делают
                                        запрещенные вещества.</p>
                                </div>
                            </div>

                            <div
                                className={`${style['overlay__characters--' + props.site]} ${style['overlay__characters']}`}>
                                <div className={glitchClass()}>
                                    <img
                                        src='https://docs.rferl.org/Infographics/2019/2019_07/2019_07_HolyWar/images/about-the-heroes/02-dmitry-belinsky.jpg'/>
                                </div>
                                <div>
                                    <h3>Дмитрий "Линкси" Белинский</h3>
                                    <p>веб-дизайнер. Существует мнение, что именно он создал "олбанский" язык и был
                                        ответственен за
                                        креатив в Фак.ру. Создал дизайн многим порносайтам в 90-х, работал на Первом
                                        канале, однако так
                                        и не смог уговорить руководство поменять дизайн.</p>
                                </div>
                            </div>

                            <div
                                className={`${style['overlay__characters--' + props.site]} ${style['overlay__characters']}`}>
                                <div className={glitchClass()}>
                                    <img
                                        src='https://docs.rferl.org/Infographics/2019/2019_07/2019_07_HolyWar/images/about-the-heroes/01-dmitry-verner.jpg'/>
                                </div>
                                <div>
                                    <h3>Дмитрий Вернер</h3>
                                    <p>профессор астрофизики и коллекционер анекдотов. Создатель сайта Anekdot.ru, на
                                        протяжении нескольких лет самого популярного сайта России. После продажи проекта
                                        работал почтальоном в США, о чем писал в своем ЖЖ.</p>
                                </div>
                            </div>

                            <div
                                className={`${style['overlay__characters--' + props.site]} ${style['overlay__characters']}`}>
                                <div className={glitchClass()}>
                                    <img
                                        src='https://docs.rferl.org/Infographics/2019/2019_07/2019_07_HolyWar/images/about-the-heroes/04-dmitry-grishin.jpg'/>
                                </div>
                                <div>
                                    <h3>Дмитрий Гришин</h3>
                                    <p>председатель совета директоров и сооснователь Mail.ru Group, занимался развитием коммуникационных
                                        сервисов и онлайн-игр компании. В 2012 году открыл в США венчурную компанию Grishin Robotics для
                                        инвестиций в робототехнику.</p>
                                </div>
                            </div>

                            <div
                                className={`${style['overlay__characters--' + props.site]} ${style['overlay__characters']}`}>
                                <div className={glitchClass()}>
                                    <img
                                        src='https://docs.rferl.org/Infographics/2019/2019_07/2019_07_HolyWar/images/about-the-heroes/07-dmitry-dumik.jpg'/>
                                </div>
                                <div>
                                    <h3>Дмитрий Думик</h3>
                                    <p>программист, предприниматель, соавтор приложения приложение Myata для фильтрации контента соцсети
                                        "ВКонтакте” в соответствии с предпочтениями пользователей и генеральный директор Chatfuel –
                                        платформы для создания чат-ботов для Facebook Messenger. Живет в США.</p>
                                </div>
                            </div>

                            <div
                                className={`${style['overlay__characters--' + props.site]} ${style['overlay__characters']}`}>
                                <div className={glitchClass()}>
                                    <img
                                        src='https://docs.rferl.org/Infographics/2019/2019_07/2019_07_HolyWar/images/about-the-heroes/01-dmitry-itzkovich.jpg'/>
                                </div>
                                <div>
                                    <h3>Дмитрий Ицкович</h3>
                                    <p>
                                        основатель и главный редактор Zhurnal.ru и Polit.ru. Создатель первого
                                        интеллектуального офлайн-клуба
                                        "Проект "ОГИ", издатель и владелец сети модных рюмочных в Москве и
                                        Санкт-Петербурге.
                                    </p>
                                </div>
                            </div>

                            <div
                                className={`${style['overlay__characters--' + props.site]} ${style['overlay__characters']}`}>
                                <div className={glitchClass()}>
                                    <img
                                        src='https://docs.rferl.org/Infographics/2019/2019_07/2019_07_HolyWar/images/about-the-heroes/03-dmitry-krukov.jpg'/>
                                </div>
                                <div>
                                    <h3>Дмитрий Крюков</h3>
                                    <p>
                                        программист, автор первой поисковой системы в России Rambler. Разработал
                                        программу в свободное от работы в Институте
                                        биохимии время и запустил в собственный день рождения как подарок самому себе.
                                        Умер в 2009 году от внутримозгового кровоизлияния.
                                    </p>
                                </div>
                            </div>

                            <div
                                className={`${style['overlay__characters--' + props.site]} ${style['overlay__characters']}`}>
                                <div className={glitchClass()}>
                                    <img
                                        src='https://docs.rferl.org/Infographics/2019/2019_07/2019_07_HolyWar/images/about-the-heroes/05-evgeny-zubarev.jpg'/>
                                </div>
                                <div>
                                    <h3>Евгений Зубарев</h3>
                                    <p>журналист. Бывший редактор "Росбалта", руководитель агентства РИА ФАН, предположительно одного из проектов
                                        "фабрики троллей". В 2018 году Минфин США ввел санкции против РИА ФАН по причине связей проекта с
                                        "поваром Путина" Евгением Пригожиным.</p>
                                </div>
                            </div>

                            <div
                                className={`${style['overlay__characters--' + props.site]} ${style['overlay__characters']}`}>
                                <div className={glitchClass()}>
                                    <img
                                        src='https://docs.rferl.org/Infographics/2019/2019_07/2019_07_HolyWar/images/about-the-heroes/07-egor-zhukov.jpg'/>
                                </div>
                                <div>
                                    <h3>Егор Жуков</h3>
                                    <p>студент, блогер, политический деятель.
                                        Член "Команды Гудкова" на выборах в Московскую городскую Думу в 2019 году.
                                        Фигурант так называемого "московского дела". Поручителями за Егора Жукова тогда
                                        выступили рэпер Мирон Фёдоров (Oxxxymiron), предложивший залог в 2 млн рублей,
                                        актриса Чулпан Хаматова, юрист ФБК Любовь Соболь и главный редактор радиостанции
                                        "Эхо Москвы" Алексей Венедиктов. Впоследствии Жукову было предъявлено обвинение в
                                        публичных призывах к экстремистской деятельности через ютуб.</p>
                                </div>
                            </div>

                            <div
                                className={`${style['overlay__characters--' + props.site]} ${style['overlay__characters']}`}>
                                <div className={glitchClass()}>
                                    <img
                                        src='https://docs.rferl.org/Infographics/2019/2019_07/2019_07_HolyWar/images/about-the-heroes/02-egor-lavrov.jpg'/>
                                </div>
                                <div>
                                    <h3>Егор "Скелетрон" Лавров</h3>
                                    <p>создатель журнала "Планета Internet" об интернете и сайта Фак.ру. В 19 лет Лавров
                                        возглавил предвыборный
                                        штаб Умара Джабраилова. Сейчас работает в каннабисной индустрии.</p>
                                </div>
                            </div>

                            <div
                                className={`${style['overlay__characters--' + props.site]} ${style['overlay__characters']}`}>
                                <div className={glitchClass()}>
                                    <img
                                        src='https://docs.rferl.org/Infographics/2019/2019_07/2019_07_HolyWar/images/about-the-heroes/03-elena-kolmanovskaja.jpg'/>
                                </div>
                                <div>
                                    <h3>Елена Колмановская</h3>
                                    <p>
                                        главный редактор Yandex до 2012 года. В 1996 году пришла работать в компанию
                                        Comptek к Аркадию Воложу.
                                        Среди ее первых заданий был "промышленный шпионаж" среди компаний,
                                        разрабатывающих системы поиска в текстах.
                                        Выяснилось, что морфология Yandex, разработанная Сегаловичем, в разы превосходит
                                        конкурентов, и коллеги решили создавать "поисковик".
                                    </p>
                                </div>
                            </div>

                            <div
                                className={`${style['overlay__characters--' + props.site]} ${style['overlay__characters']}`}>
                                <div className={glitchClass()}>
                                    <img
                                        src='https://docs.rferl.org/Infographics/2019/2019_07/2019_07_HolyWar/images/about-the-heroes/01-emelyan-zaharov.jpg'/>
                                </div>
                                <div>
                                    <h3>Емельян Захаров</h3>
                                    <p>
                                        один их первых импортеров компьютеров в Россию, галерист. В настоящее время
                                        совладелец
                                        галереи современного искусства "Триумф".
                                    </p>
                                </div>
                            </div>

                            <div
                                className={`${style['overlay__characters--' + props.site]} ${style['overlay__characters']}`}>
                                <div className={glitchClass()}>
                                    <img
                                        src='https://docs.rferl.org/Infographics/2019/2019_07/2019_07_HolyWar/images/about-the-heroes/06-Ivan-Kolpakov.jpg'/>
                                </div>
                                <div>
                                    <h3>Иван Колпаков</h3>
                                    <p>
                                    журналист, один из основателей интернет-газеты "Соль",
                                    главный редактор издания Meduza с 2016 по 2018 год и с марта 2019 года.
                                    </p>
                                </div>
                            </div>

                            <div
                                className={`${style['overlay__characters--' + props.site]} ${style['overlay__characters']}`}>
                                <div className={glitchClass()}>
                                    <img
                                        src='https://docs.rferl.org/Infographics/2019/2019_07/2019_07_HolyWar/images/about-the-heroes/03-igor-ashmanov.jpg'/>
                                </div>
                                <div>
                                    <h3>Игорь Ашманов</h3>
                                    <p>
                                        IT-предприниматель, исполнительный директор Rambler с 1999 по 2001 год. С 2012
                                        по 2017 год являлся сопредседателем
                                        "Партии Великое Отечество" Николая Старикова. С 2014 года участвует в Менторской
                                        программе Фонда "Сколкова".
                                        Во время президентских выборов в 2018 году был доверенным лицом Владимира
                                        Путина. Автор книги "Жизнь внутри
                                        пузыря" о работе в компании Rambler. Известен своими агрессивными высказываниями
                                        о войнах в киберпространстве
                                        и необходимости защищаться.
                                    </p>
                                </div>
                            </div>

                            <div
                                className={`${style['overlay__characters--' + props.site]} ${style['overlay__characters']}`}>
                                <div className={glitchClass()}>
                                    <img
                                        src='https://docs.rferl.org/Infographics/2019/2019_07/2019_07_HolyWar/images/about-the-heroes/07-big-russian-boss.jpg'/>
                                </div>
                                <div>
                                    <h3>Игорь Лавров (Big russian boss)</h3>
                                    <p>блогер, рэп-музыкант. В своем шоу появляется в основном в шубе, 
                                        с золотыми цепями, чёрными очками и накладной бородой. С 2016 года сотрудничает с телеканалом ТНТ.
                                        У ютуб-канала Лаврова более 2,9 миллионов подписчиков.
                                    </p>
                                </div>
                            </div>

                            <div
                                className={`${style['overlay__characters--' + props.site]} ${style['overlay__characters']}`}>
                                <div className={glitchClass()}>
                                    <img
                                        src='https://docs.rferl.org/Infographics/2019/2019_07/2019_07_HolyWar/images/about-the-heroes/04-igor-matzanuk.jpg'/>
                                </div>
                                <div>
                                    <h3>Игорь Мацанюк</h3>
                                    <p>
                                        предприниматель, соучредитель IT Territory, одной из первых компаний-разработчиков онлайн-игр в России.
                                        Окончил Высшее инженерное морское училище, в 90-х занимался продажей автомобильных запчастей. В 2004 году
                                        открыл компанию It Territory совместно с Сергеем Жуковым, а после – компанию Game insight. Живет в США.
                                    </p>
                                </div>
                            </div>

                            <div
                                className={`${style['overlay__characters--' + props.site]} ${style['overlay__characters']}`}>
                                <div className={glitchClass()}>
                                    <img
                                        src='https://docs.rferl.org/Infographics/2019/2019_07/2019_07_HolyWar/images/about-the-heroes/05-ilya-varlamov.jpg'/>
                                </div>
                                <div>
                                    <h3>Илья Варламов</h3>
                                    <p>
                                        общественный деятель, блогер, автор одного из самых популярных страниц в ЖЖ. Большинство материалов посвящены
                                        теме урбанистики. В 2012 году вместе с Максимом Кацем создал фонд "Городские проекты" с целью улучшить
                                        российскую городскую среду. В 2018 году основал фонд "Внимание!", занимающийся проблемами восстановления
                                        облика исторических зданий в России.
                                    </p>
                                </div>
                            </div>

                            <div
                                className={`${style['overlay__characters--' + props.site]} ${style['overlay__characters']}`}>
                                <div className={glitchClass()}>
                                    <img
                                        src='https://docs.rferl.org/Infographics/2019/2019_07/2019_07_HolyWar/images/about-the-heroes/03-ilya-segalovich.jpg'/>
                                </div>
                                <div>
                                    <h3>Илья Сегалович</h3>
                                    <p>
                                        программист, предприниматель, сооснователь и директор по технологиям Yandex.
                                        Познакомился со вторым основателем
                                        компании Аркадием Воложем в 1977 году во время учебы в школе в Алма-Ате. В
                                        1981-м они вместе переехали в Москву,
                                        чтобы поступить на геологический факультет МГУ, но оба не прошли конкурс.
                                        Разработчик морфологии поисковика и
                                        создатель первого российского сервиса контекстной рекламы "Яндекс. Директ". Умер
                                        в 2013 году от рака мозга.
                                    </p>
                                </div>
                            </div>

                            <div
                                className={`${style['overlay__characters--' + props.site]} ${style['overlay__characters']}`}>
                                <div className={glitchClass()}>
                                    <img
                                        src='https://docs.rferl.org/Infographics/2019/2019_07/2019_07_HolyWar/images/about-the-heroes/07-ilya-prusikin.jpg'/>
                                </div>
                                <div>
                                    <h3>Илья ("Ильич") Прусикин</h3>
                                    <p>
                                    российский музыкант, видеоблогер, лидер группы Little big.
                                    Автор двух шоу, выходивших на ютуб-канале "Спасибо, Ева!", "Шоу Гаффи Гафа" и
                                    "Великая рэп-битва". Один из создателей объединения блогеров "КЛИККЛАК".
                                    В августе 2019 года стал креативным директором "Связного-Евросеть".
                                    Клип на песню Skibidi стал самым популярным российским видео в мире.
                                    </p>
                                </div>
                            </div>

                            <div
                                className={`${style['overlay__characters--' + props.site]} ${style['overlay__characters']}`}>
                                <div className={glitchClass()}>
                                    <img
                                        src='https://docs.rferl.org/Infographics/2019/2019_07/2019_07_HolyWar/images/about-the-heroes/01-iosif-goldin.jpg'/>
                                </div>
                                <div>
                                    <h3>Иосиф Гольдин</h3>
                                    <p>
                                        сценарист с репутацией "городского сумасшедшего". Организатор "сеансов по
                                        раскрепощению памяти",
                                        любитель гипноза, психологии и скрытых возможностей человека.
                                    </p>
                                </div>
                            </div>

                            <div
                                className={`${style['overlay__characters--' + props.site]} ${style['overlay__characters']}`}>
                                <div className={glitchClass()}>
                                    <img
                                        src='https://docs.rferl.org/Infographics/2019/2019_07/2019_07_HolyWar/images/about-the-heroes/05-konstantin-malofeev.jpg'/>
                                </div>
                                <div>
                                    <h3>Константин Малофеев</h3>
                                    <p>предприниматель, основатель телеканала Царьград ТВ, основатель и член попечительского совета
                                        "Лиги безопасного интернета". Осенью 2019 года занял пост председателя наблюдательного совета
                                        Международного агентства суверенного развития – негосударственной организации, которая, по
                                        словам Малофеева помогает "с экономическим реформированием тем странам, которые пытаются
                                        освободиться от экономической и финансовой зависимости от западного мира".</p>
                                </div>
                            </div>

                            <div
                                className={`${style['overlay__characters--' + props.site]} ${style['overlay__characters']}`}>
                                <div className={glitchClass()}>
                                    <img
                                        src='https://docs.rferl.org/Infographics/2019/2019_07/2019_07_HolyWar/images/about-the-heroes/02-konstantin-rykov.jpg'/>
                                </div>
                                <div>
                                    <h3>Константин "Форис" Рыков</h3>
                                    <p>создатель сайта Фак.ру, медиаменеджер, депутат Государственной думы V созыва. В
                                        течение двух лет возглавлял интернет-департамент
                                        Первого канала. Создатель ряда интернет-кампаний в поддержку Владимира Путина и
                                        Дмитрия Медведева.</p>
                                </div>
                            </div>

                            <div
                                className={`${style['overlay__characters--' + props.site]} ${style['overlay__characters']}`}>
                                <div className={glitchClass()}>
                                    <img
                                        src='https://docs.rferl.org/Infographics/2019/2019_07/2019_07_HolyWar/images/about-the-heroes/05-kristina-potupchik.jpg'/>
                                </div>
                                <div>
                                    <h3>Кристина Потупчик</h3>
                                    <p>общественный деятель, блогер. Бывший комиссар и пресс-секретарь движения "Наши", бывший пресс-секретарь
                                        агентства Росмолодежь и член Общественной палаты РФ 5-го состава.</p>
                                </div>
                            </div>

                            <div
                                className={`${style['overlay__characters--' + props.site]} ${style['overlay__characters']}`}>
                                <div className={glitchClass()}>
                                    <img
                                        src='https://docs.rferl.org/Infographics/2019/2019_07/2019_07_HolyWar/images/about-the-heroes/06-Lev-Gershenzon.jpg'/>
                                </div>
                                <div>
                                    <h3>Лев Гершензон</h3>
                                    <p>бывший руководитель службы "Яндекс. Новости" (2008-2012), участник протестных митингов в России.
                                        В настоящее время живет в Берлине и
                                        развивает свой стартап, уже ставший успешным, – поисковик для онлайн-магазинов "Детектум".</p>
                                </div>
                            </div>

                            <div
                                className={`${style['overlay__characters--' + props.site]} ${style['overlay__characters']}`}>
                                <div className={glitchClass()}>
                                    <img
                                        src='https://docs.rferl.org/Infographics/2019/2019_07/2019_07_HolyWar/images/about-the-heroes/04-lev-leviev.jpg'/>
                                </div>
                                <div>
                                    <h3>Лев Левиев</h3>
                                    <p>
                                        инвестор, предприниматель, сооснователь "ВКонтакте". Вырос в Волгограде, в 90-х переехал в Израиль,
                                        где во время учебы в школе познакомился с будущим партнером по бизнесу Вячеславом Мирилашвили.
                                        Окончил Университет Макгилла в Канаде. Сооснователь компании-оператора дата-центров Selectel и
                                        платформы BlockTrail для операций с биткоинами.
                                    </p>
                                </div>
                            </div>

                            <div
                                className={`${style['overlay__characters--' + props.site]} ${style['overlay__characters']}`}>
                                <div className={glitchClass()}>
                                    <img
                                        src='https://docs.rferl.org/Infographics/2019/2019_07/2019_07_HolyWar/images/about-the-heroes/06-Lena-Klimova.jpg'/>
                                </div>
                                <div>
                                    <h3>Лена Климова</h3>
                                    <p>
                                    журналист, ЛГБТ-активистка, создатель просветительского проекта "Дети-404",
                                    занимающегося проблемами ЛГБТ-подростков. В 2015 году была оштрафована за "
                                    пропаганду нетрадиционных сексуальных отношений среди несовершеннолетних".
                                    Автор серии фотоколлажей "Красивые люди и то, что они говорят мне" о гомофобии.
                                    </p>
                                </div>
                            </div>
                            
                            <div
                                className={`${style['overlay__characters--' + props.site]} ${style['overlay__characters']}`}>
                                <div className={glitchClass()}>
                                    <img
                                        src='https://docs.rferl.org/Infographics/2019/2019_07/2019_07_HolyWar/images/about-the-heroes/03-leonid-bogislavsky.jpg'/>
                                </div>
                                <div>
                                    <h3>Леонид Богуславский</h3>
                                    <p>
                                        венчурный инвестор. Родился в семье литератора Зои Богуславской и инженера
                                        Бориса Кагана, пасынок поэта Андрея Вознесенского.
                                        С 1990 года занимался компьютерным бизнесом. В 2000 году создал инвестиционную
                                        компанию ru-Net Holdings. Среди первых проектов
                                        которой стали Yandex и Ozon. В 2017 году вошел в попечительский совет Сбербанка.
                                        По состоянию на 2019 год занял 95-е место
                                        в списке русского Forbes.
                                    </p>
                                </div>
                            </div>

                            <div
                                className={`${style['overlay__characters--' + props.site]} ${style['overlay__characters']}`}>
                                <div className={glitchClass()}>
                                    <img
                                        src='https://docs.rferl.org/Infographics/2019/2019_07/2019_07_HolyWar/images/about-the-heroes/07-leonid-parfenov.jpg'/>
                                </div>
                                <div>
                                    <h3>Леонид Парфенов</h3>
                                    <p>
                                    журналист, писатель, телеведущий, блогер, режиссер. Автор телепроектов "Намедни" и
                                    "Российская империя". С 1997-го до 1999-го был главным продюсером телеканала НТВ.
                                    В 2012 году начал работать на телеканале "Дождь", в 2018-м открыл авторское шоу в ютубе "Парфенон".
                                    </p>
                                </div>
                            </div>


                            <div
                                className={`${style['overlay__characters--' + props.site]} ${style['overlay__characters']}`}>
                                <div className={glitchClass()}>
                                    <img
                                        src='https://docs.rferl.org/Infographics/2019/2019_07/2019_07_HolyWar/images/about-the-heroes/05-ludmila-savshuk.jpg'/>
                                </div>
                                <div>
                                    <h3>Людмила Савчук</h3>
                                    <p>журналист, экс-сотрудница петербургской "фабрики троллей", активистка движения "Информационный мир".
                                    </p>
                                </div>
                            </div>

                            <div
                                className={`${style['overlay__characters--' + props.site]} ${style['overlay__characters']}`}>
                                <div className={glitchClass()}>
                                    <img
                                        src='https://docs.rferl.org/Infographics/2019/2019_07/2019_07_HolyWar/images/about-the-heroes/06-Michael-Calvi.jpg'/>
                                </div>
                                <div>
                                    <h3>Майкл Калви</h3>
                                    <p>международный инвестовр, основатель фонда Baring Vostok Capital Partners,
                                        специализирующегося на инвестициях в России и странах СНГ. Инвестировал такие проекты,
                                        как Avito, "1C", "Вкусвилл", Busfor, "Тинькофф банк" и многие другие.
                                        Общий объем инвестиций фонда с 1994 года превысил $2,4 млрд.
                                        В 2019 году Калви предъявили обвинения в мошенничестве в особо крупном размере,
                                        арестовав все его имущество. Инвестор находится под домашним арестом.
                                    </p>
                                </div>
                            </div>

                            <div
                                className={`${style['overlay__characters--' + props.site]} ${style['overlay__characters']}`}>
                                <div className={glitchClass()}>
                                    <img
                                        src='https://docs.rferl.org/Infographics/2019/2019_07/2019_07_HolyWar/images/about-the-heroes/01-maxim-moshkov.jpg'/>
                                </div>
                                <div>
                                    <h3>Максим Мошков</h3>
                                    <p>
                                        программист, веб-разработчик. Бывший сотрудник НИИ системных исследований РАН.
                                        Создатель "Библиотеки Максима Мошкова."
                                    </p>
                                </div>
                            </div>

                            <div
                                className={`${style['overlay__characters--' + props.site]} ${style['overlay__characters']}`}>
                                <div className={glitchClass()}>
                                    <img
                                        src='https://docs.rferl.org/Infographics/2019/2019_07/2019_07_HolyWar/images/about-the-heroes/00-marina-litvinovich.jpg'/>
                                </div>
                                <div>
                                    <h3>Марина Литвинович</h3>
                                    <p>
                                        политолог, правозащитник. С 1996 по 2002 год работала директором по новом
                                        проектам в ФЭП. Разрабатывала
                                        официальный сайт Бориса Немцова. Принимала участие в избирательных кампаниях
                                        Сергея Кириенко, Ирины Хакамады,
                                        Виктора Шендеровича и Ксении Собчак. Бывший политический советник Гарри
                                        Каспарова и Михаила Ходорковского.
                                        Создатель сайта "Правда Беслана" и одна из организаторов "Маршей несогласных".
                                    </p>
                                </div>
                            </div>

                            <div
                                className={`${style['overlay__characters--' + props.site]} ${style['overlay__characters']}`}>
                                <div className={glitchClass()}>
                                    <img
                                        src='https://docs.rferl.org/Infographics/2019/2019_07/2019_07_HolyWar/images/about-the-heroes/03-mikhail-rogalsky.jpg'/>
                                </div>
                                <div>
                                    <h3>Михаил Рогальский</h3>
                                    <p>
                                        российский предприниматель, программист, создатель старейшего сайта об
                                        автомобилях Auto.ru.
                                        Родился в семье инженеров, окончил РГУ нефти и газа по специальности
                                        "Электроника и информатика".
                                        После работы риэлтером в 90-х создал первую базу московской недвижимости. В 1996
                                        году зарегистрировал
                                        домены Realty.ru и Auto.ru. В 2014 году продал сайт Auto.ru компании Yandex за
                                        $175 млн.
                                    </p>
                                </div>
                            </div>

                            <div
                                className={`${style['overlay__characters--' + props.site]} ${style['overlay__characters']}`}>
                                <div className={glitchClass()}>
                                    <img
                                        src='https://docs.rferl.org/Infographics/2019/2019_07/2019_07_HolyWar/images/about-the-heroes/01-modest-kolerov.jpg'/>
                                </div>
                                <div>
                                    <h3>Модест Колеров</h3>
                                    <p>
                                        историк, издатель. Главный редактор и соучредитель информагентства REGNUM,
                                        президент издательского дома "Регнум".
                                        За ряд публикаций Колерову запрещен въезд в Литву, Эстонию и Латвию.
                                    </p>
                                </div>
                            </div>

                            <div
                                className={`${style['overlay__characters--' + props.site]} ${style['overlay__characters']}`}>
                                <div className={glitchClass()}>
                                    <img
                                        src='https://docs.rferl.org/Infographics/2019/2019_07/2019_07_HolyWar/images/about-the-heroes/04-nikolay-kononov.jpg'/>
                                </div>
                                <div>
                                    <h3>Николай Кононов</h3>
                                    <p>
                                        журналист, писатель. Бывший главный редактор журнала "Секрет фирмы". Автор книг "Код Дурова"
                                        о создателе "ВКонтакте" и "Восстание" об одном из лидеров восстания заключенных в норильском
                                        лагере в 1953 году.
                                    </p>
                                </div>
                            </div>

                            <div
                                className={`${style['overlay__characters--' + props.site]} ${style['overlay__characters']}`}>
                                <div className={glitchClass()}>
                                    <img
                                        src='https://docs.rferl.org/Infographics/2019/2019_07/2019_07_HolyWar/images/about-the-heroes/07-nikolay-sobolev.jpg'/>
                                </div>
                                <div>
                                    <h3>Николай Соболев</h3>
                                    <p>блогер, один из основателей коллективов Rakamakafo и Ready Steady Go.
                                        У авторского ютуб-канала Соболева более 5 миллионов подписчиков.
                                    </p>
                                </div>
                            </div>

                            <div
                                className={`${style['overlay__characters--' + props.site]} ${style['overlay__characters']}`}>
                                <div className={glitchClass()}>
                                    <img
                                        src='https://docs.rferl.org/Infographics/2019/2019_07/2019_07_HolyWar/images/about-the-heroes/03-oleg-radzinsky.jpg'/>
                                </div>
                                <div>
                                    <h3>Олег Радзинский</h3>
                                    <p>
                                        писатель, диссидент, инвестиционный банкир. Родился в семье драматурга Эдварда
                                        Радзинского и актрисы
                                        Аллы Гераскиной. Окончил филологический факультет МГУ. В 1982 году был арестован
                                        на пять лет по статье
                                        "Антисоветская агитация и пропаганда". В 1987 году был выслан из страны и
                                        поселился в США, где поступил
                                        в Колумбийский университет. Совладелец Rambler Media Group в 2002-2006-м.
                                        Благодаря усилиям Радзинского
                                        компания в 2005 году вышла на IPO.
                                    </p>
                                </div>
                            </div>

                            <div
                                className={`${style['overlay__characters--' + props.site]} ${style['overlay__characters']}`}>
                                <div className={glitchClass()}>
                                    <img
                                        src='https://docs.rferl.org/Infographics/2019/2019_07/2019_07_HolyWar/images/about-the-heroes/05-olga-romanova.jpg'/>
                                </div>
                                <div>
                                    <h3>Ольга Романова</h3>
                                    <p>
                                        журналист, телеведущая. Бывший член Координационного совета российской оппозиции, исполнительный директор
                                        движения "Русь сидящая". Соавтор интернет-дневника "Бутырка-блог", написанного вместе с мужем,
                                        предпринимателем Алексеем Козловым, арестованным в 2008 году. С 2011 года руководила департаментом
                                        журналистики на факультете медиакоммуникаций Высшей школы экономики. В 2017 году переехала жить
                                        и работать в Германию по причине судебного разбирательства с ФСИН.
                                    </p>
                                </div>
                            </div>

                            <div
                                className={`${style['overlay__characters--' + props.site]} ${style['overlay__characters']}`}>
                                <div className={glitchClass()}>
                                    <img
                                        src='https://docs.rferl.org/Infographics/2019/2019_07/2019_07_HolyWar/images/about-the-heroes/04-pavel-durov.jpg'/>
                                </div>
                                <div>
                                    <h3>Павел Дуров</h3>
                                    <p>
                                        программист, предприниматель, сооснователь "ВКонтакте". Окончил филологический факультет СПБГУ по специальности
                                        "Английская филология и перевод". В 2013 году покинул Россию, заявив, что "в этой стране невозможно вести бизнес".
                                        В том же году запустил мессенджер Telegram.
                                    </p>
                                </div>
                            </div>

                            <div
                                className={`${style['overlay__characters--' + props.site]} ${style['overlay__characters']}`}>
                                <div className={glitchClass()}>
                                    <img
                                        src='https://docs.rferl.org/Infographics/2019/2019_07/2019_07_HolyWar/images/about-the-heroes/05-petr-shkumatov.jpg'/>
                                </div>
                                <div>
                                    <h3>Петр Шкуматов</h3>
                                    <p>
                                        блогер, координатор движения "Общество синих ведерок". Один из учредителей "Лиги избирателей"
                                        – организации, созданной для контроля за президентскими выборами в 2012 году.
                                    </p>
                                </div>
                            </div>

                            <div
                                className={`${style['overlay__characters--' + props.site]} ${style['overlay__characters']}`}>
                                <div className={glitchClass()}>
                                    <img
                                        src='https://docs.rferl.org/Infographics/2019/2019_07/2019_07_HolyWar/images/about-the-heroes/07-roma-zhelud.jpg'/>
                                </div>
                                <div>
                                    <h3>Рома Желудь</h3>
                                    <p>
                                    видеоблогер, музыкант. На волне успеха в ютубе пробовал себя в качестве певца, телеведущего и дизайнера.
                                    Общее количество просмотров на двух каналах Желудя (RomaAcorn и RomaAcornLive) на февраль 2015
                                    года превышало 108 миллионов. В марте 2015 года переехал жить в США, но спустя время вернулся в Россию.
                                    </p>
                                </div>
                            </div>

                            <div
                                className={`${style['overlay__characters--' + props.site]} ${style['overlay__characters']}`}>
                                <div className={glitchClass()}>
                                    <img
                                        src='https://docs.rferl.org/Infographics/2019/2019_07/2019_07_HolyWar/images/about-the-heroes/07-ruslan-usachev.jpg'/>
                                </div>
                                <div>
                                    <h3>Руслан Усачев</h3>
                                    <p>видеоблогер, автор шоу Usachev today, выходившего на канале "Спасибо, Ева!",
                                        а также проектов "Вредное кино", Twitotta, "Микрообзоры" и "Пора валить".
                                        Сейчас у ютуб-канала Усачева около 2 миллионов подписчиков.
                                    </p>
                                </div>
                            </div>

                            <div
                                className={`${style['overlay__characters--' + props.site]} ${style['overlay__characters']}`}>
                                <div className={glitchClass()}>
                                    <img
                                        src='https://docs.rferl.org/Infographics/2019/2019_07/2019_07_HolyWar/images/about-the-heroes/06-Svetlana-Reiter.jpg'/>
                                </div>
                                <div>
                                    <h3>Светлана Рейтер</h3>
                                    <p>
                                    журналист, писатель. Бывший специальный корреспондент "Lenta.ru".
                                    Автор книги "Сами по себе" – сборника статей "о беспросветности русской жизни".
                                    </p>
                                </div>
                            </div>

                            <div
                                className={`${style['overlay__characters--' + props.site]} ${style['overlay__characters']}`}>
                                <div className={glitchClass()}>
                                    <img
                                        src='https://docs.rferl.org/Infographics/2019/2019_07/2019_07_HolyWar/images/about-the-heroes/05-sergey-bolshakov.jpg'/>
                                </div>
                                <div>
                                    <h3>Сергей Большаков</h3>
                                    <p>
                                        общественный деятель. Бывший командир студенческого трудового отряда, бывший председатель
                                        "Тверского городского молодежного совета". Сейчас специалист Тверской "Кибердружины".
                                    </p>
                                </div>
                            </div>

                            <div
                                className={`${style['overlay__characters--' + props.site]} ${style['overlay__characters']}`}>
                                <div className={glitchClass()}>
                                    <img
                                        src='https://docs.rferl.org/Infographics/2019/2019_07/2019_07_HolyWar/images/about-the-heroes/03-sergey-vasiliev.jpg'/>
                                </div>
                                <div>
                                    <h3>Сергей Васильев</h3>
                                    <p>
                                        совладелец и первый инвестор компании Rambler. В 2005 году написал серию очерков
                                        об истории компании.
                                    </p>
                                </div>
                            </div>


                            <div
                                className={`${style['overlay__characters--' + props.site]} ${style['overlay__characters']}`}>
                                <div className={glitchClass()}>
                                    <img
                                        src='https://docs.rferl.org/Infographics/2019/2019_07/2019_07_HolyWar/images/about-the-heroes/04-sergey-zhukov.jpg'/>
                                </div>
                                <div>
                                    <h3>Сергей Жуков</h3>
                                    <p>
                                        музыкант, солист группы "Руки Вверх!" Один из соучредителей компании It Territory, создавшей онлайн-игры
                                        "Территория" и "Легенда: Наследия Драконов". В 2005 году продал свою долю компании Mail.ru Group.
                                    </p>
                                </div>
                            </div>

                            <div
                                className={`${style['overlay__characters--' + props.site]} ${style['overlay__characters']}`}>
                                <div className={glitchClass()}>
                                    <img
                                        src='https://docs.rferl.org/Infographics/2019/2019_07/2019_07_HolyWar/images/about-the-heroes/03-sergey-lisakov.jpg'/>
                                </div>
                                <div>
                                    <h3>Сергей Лысаков</h3>
                                    <p>
                                        программист, сооснователь и бывший генеральный директор Rambler. До открытия
                                        компании вместе
                                        с Дмитрием Крюковым работал в Институте биохимии в Пущине.
                                    </p>
                                </div>
                            </div>


                            <div
                                className={`${style['overlay__characters--' + props.site]} ${style['overlay__characters']}`}>
                                <div className={glitchClass()}>
                                    <img
                                        src='https://docs.rferl.org/Infographics/2019/2019_07/2019_07_HolyWar/images/about-the-heroes/02-stepan-eremin.jpg'/>
                                </div>
                                <div>
                                    <h3>Степан Еремин</h3>
                                    <p>разработчик и руководитель портала Padonki.org, создатель асоциального проекта
                                        Х*ЯNDEX и прочих. Сейчас занимается
                                        проектом Kaktam.tv – ютуб-каналом с матерными новостями.
                                    </p>
                                </div>
                            </div>

                            <div
                                className={`${style['overlay__characters--' + props.site]} ${style['overlay__characters']}`}>
                                <div className={glitchClass()}>
                                    <img
                                        src='https://docs.rferl.org/Infographics/2019/2019_07/2019_07_HolyWar/images/about-the-heroes/07-sam-nickel.jpg'/>
                                </div>
                                <div>
                                    <h3>Сэм Никель</h3>
                                    <p>блогер, музыкант. Один из авторов и главное действующее лицо блога My Duck's Vision.
                                        Лидер группы Candid8.
                                    </p>
                                </div>
                            </div>

                            <div
                                className={`${style['overlay__characters--' + props.site]} ${style['overlay__characters']}`}>
                                <div className={glitchClass()}>
                                    <img
                                        src='https://docs.rferl.org/Infographics/2019/2019_07/2019_07_HolyWar/images/about-the-heroes/06-Tim-Bernes-Li.jpg'/>
                                </div>
                                <div>
                                    <h3>Тим Бернерс-Ли</h3>
                                    <p>
                                        изобретатель URI, URL, HTTP, HTML, создатель Всемирной паутины (совместно с Робертом Кайо)
                                        и действующий глава Консорциума Всемирной паутины. Автор концепции семантической паутины.
                                        Автор множества других разработок в области информационных технологий.
                                    </p>
                                </div>
                            </div>

                            <div
                                className={`${style['overlay__characters--' + props.site]} ${style['overlay__characters']}`}>
                                <div className={glitchClass()}>
                                    <img
                                        src='https://docs.rferl.org/Infographics/2019/2019_07/2019_07_HolyWar/images/about-the-heroes/07-yury-degtyarev.jpg'/>
                                </div>
                                <div>
                                    <h3>Юрий Дегтярев</h3>
                                    <p>основатель одного из первых русскоязычных ютуб-блогов My Duck's vision.
                                        Бывший работник Rutube и один из создателей "Спасибо, Ева!"
                                    </p>
                                </div>
                            </div>

                            <div
                                className={`${style['overlay__characters--' + props.site]} ${style['overlay__characters']}`}>
                                <div className={glitchClass()}>
                                    <img
                                        src='https://docs.rferl.org/Infographics/2019/2019_07/2019_07_HolyWar/images/about-the-heroes/07-yury-dud.jpg'/>
                                </div>
                                <div>
                                    <h3>Юрий Дудь</h3>
                                    <p>журналист, блогер. Бывший главный редактор издания Sports.ru.
                                        С 2017 года — ведущий авторского шоу на ютуб-канале "вДудь", где берет неформальные интервью у
                                        известных людей. У канала Дудя более 6,2 миллионов подписчиков.
                                    </p>
                                </div>
                            </div>

                            <div
                                className={`${style['overlay__characters--' + props.site]} ${style['overlay__characters']}`}>
                                <div className={glitchClass()}>
                                    <img
                                        src='https://docs.rferl.org/Infographics/2019/2019_07/2019_07_HolyWar/images/about-the-heroes/03-yury-milner.jpg'/>
                                </div>
                                <div>
                                    <h3>Юрий Мильнер</h3>
                                    <p>
                                        один из самых влиятельных глобальных инвесторов, выпускник Уортонской школы
                                        бизнеса. В 90-х занимал пост гендиректора компании
                                        "Альянс-Менатеп", был вице-президентом банка "Менатеп", принадлежащего Михаилу
                                        Ходорковскому и Платону Лебедеву.
                                        Инвестировал в Facebook, Twitter, WhatsApp, AirBnB. Бывший совладелец и
                                        председатель совета директоров Mail.ru Group – технологической
                                        компании, владеющей "ВКонтакте", "Одноклассниками", Mamba.ru и десятками других
                                        платформ. В 2012 году Мильнер ушел из Mail.ru Group,
                                        решив полностью сфокусироваться на зарубежных проектах.
                                    </p>
                                </div>
                            </div>

                            <div
                                className={`${style['overlay__characters--' + props.site]} ${style['overlay__characters']}`}>
                                <div className={glitchClass()}>
                                    <img
                                        src='https://docs.rferl.org/Infographics/2019/2019_07/2019_07_HolyWar/images/about-the-heroes/07-ice-peak.jpg'/>
                                </div>
                                <div>
                                    <h3>IC3PEAK (Настя Креслина, Николай Костылев)</h3>
                                    <p>музыкальная витч-хаус группа. Позиционируют себя как "интернет-группа".
                                        С 2018 года концерты группы в российских городах отменяют
                                        представители правоохранительных органов.
                                    </p>
                                </div>
                            </div>

                        </div>
                    }

                    {
                        props.content === 'episodes' &&
                        <div className={`${style['overlay__episodes']}`}>
                            <h1>
                                Эпизоды
                            </h1>
                            <div
                                className={`${style['o__episode--' + props.site]} ${style['o__episode']}`}
                                onClick={() => changeEpisode(0)}
                            >
                                <img
                                    src='https://docs.rferl.org/Infographics/2019/2019_07/2019_07_HolyWar/images/splash/computer--0.png'/>
                                <h2>На главную</h2>
                            </div>
                            <div
                                className={`${style['o__episode--' + props.site]} ${style['o__episode']}`}
                                onClick={() => changeEpisode(1)}
                            >
                                <img
                                    src='https://docs.rferl.org/Infographics/2019/2019_07/2019_07_HolyWar/images/splash/computer--1.png'/>
                                <h2>Эпизод 1</h2>
                            </div>
                            <div
                                className={`${style['o__episode--' + props.site]} ${style['o__episode']}`}
                                onClick={() => changeEpisode(2)}
                            >
                                <img
                                    src='https://docs.rferl.org/Infographics/2019/2019_07/2019_07_HolyWar/images/splash/computer--2.png'/>
                                <h2>Эпизод 2</h2>
                            </div>
                            <div
                                className={`${style['o__episode--' + props.site]} ${style['o__episode']}`}
                                onClick={() => changeEpisode(3)}
                            >
                                <img
                                    src='https://docs.rferl.org/Infographics/2019/2019_07/2019_07_HolyWar/images/splash/computer--3.png'/>
                                <h2>Эпизод 3</h2>
                            </div>
                            <div
                                className={`${style['o__episode--' + props.site]} ${style['o__episode']}`}
                                onClick={() => changeEpisode(4)}>
                                <img
                                    src='https://docs.rferl.org/Infographics/2019/2019_07/2019_07_HolyWar/images/splash/computer--4.png'/>
                                <h2>Эпизод 4</h2>
                            </div>
                            <div
                                className={`${style['o__episode--' + props.site]} ${style['o__episode']}`}
                                onClick={() => changeEpisode(5)}>
                                <img
                                    src='https://docs.rferl.org/Infographics/2019/2019_07/2019_07_HolyWar/images/splash/computer--5.png'/>
                                <h2>Эпизод 5</h2>
                            </div>
                            <div
                                className={`${style['o__episode--' + props.site]} ${style['o__episode']}`}
                                onClick={() => changeEpisode(6)}>
                                <img
                                    src='https://docs.rferl.org/Infographics/2019/2019_07/2019_07_HolyWar/images/splash/computer--6.png'/>
                                <h2>Эпизод 6</h2>
                            </div>
                            <div
                                className={`${style['o__episode--' + props.site]} ${style['o__episode']}`}
                                onClick={() => changeEpisode(7)}>
                                <img
                                    src='https://docs.rferl.org/Infographics/2019/2019_07/2019_07_HolyWar/images/splash/computer--7.png'/>
                                <h2>Эпизод 7</h2>
                            </div>

                        </div>
                    }
                </div>
            </div>
            : <div></div>
    )
};

export default Overlay;
